import { Root } from "protobufjs";

export type TEncodeData = ArrayBuffer;
export type TDecodeData = Record<string, any>;

/**
 * 编码接口参数为 buffer
 * @param root 接口结构体文件
 * @param desction 结构体名称
 * @param data 用户参数数据
 * @returns
 */
export const encode = (
  root: Root,
  desction: string,
  data: Record<string, unknown>
): TEncodeData => {
  const desctionData = root.lookupType(desction);
  const err = desctionData.verify(data);

  if (err) {
    console.error("Encode data error:", err);
    throw Error(err);
  }

  return desctionData.encode(desctionData.create(data)).finish();
};

/**
 *  解码接口获取的 buffer
 * @param root 接口结构体文件
 * @param desction 结构体名称
 * @param data 接口获取的数据
 * @returns
 */
export const decode = (
  root: Root,
  desction: string,
  data: Uint8Array
): TDecodeData => {
  const desctionData = root.lookupType(desction);
  const err = desctionData.verify(data);

  if (err) {
    console.error("Decode data error:", err);
    throw Error(err);
  }

  return desctionData.toObject(desctionData.decode(data), { defaults: true });
};
